/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChainMethodsResponse
 */
export interface ChainMethodsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ChainMethodsResponse
     */
    list: Array<string>;
}

export function ChainMethodsResponseFromJSON(json: any): ChainMethodsResponse {
    return ChainMethodsResponseFromJSONTyped(json, false);
}

export function ChainMethodsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainMethodsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': json['list'],
    };
}

export function ChainMethodsResponseToJSON(value?: ChainMethodsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': value.list,
    };
}


